import { Component, ElementRef, ViewChild, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SsoAuthService } from '../../sso-auth.service';
import { PhilDropdownComponent } from "../../phil-dropdown/phil-dropdown.component";
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MobileChangePopup } from './mobile-change-popup/mobile-change-popup';
import { environment } from '../../../environments/environment';

export interface IMember {
  firstName: string;
  middleName: string | null;
  lastName: string;
  fullName: string;
  familyCode: string;
  memberCode: string;
  contactNo: string;
  email: string;
  panNo: string;
  aadharNo: string;
  addressLine1: string;
  addressLine2: string | null;
  dpMemKey: string | null;
  postOffice: string | null;
  state: string;
  district: string;
  ritwikName: string | null;
  pincode: string | null;
  country: string | null;

}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.html',
  styleUrls: ['./dashboard.scss'],
  imports: [
    ReactiveFormsModule],
})
export class Dashboard implements OnInit {
  memberDetails!: IMember;
  showApps: boolean = false;
  isEditMode: boolean = false;
  profileForm!: FormGroup;
  pinDetails: string[] = []
  allStates: string[] = [];
  selectedState: string = '';
  allDistricts: string[] = [];
  selectedDistrict: string[] = [];
  allPostOffices: any = [];
  selectedPostOffice: string = '';
  selectedPinCode: string = '';
  isUpdateNo: boolean = false
  id: string = ''
  multiStateDataFromPincode: any;

  orgUrl = environment.orgUrl;
  accoUrl = environment.accoUrl;
  onlineIvUrl = environment.onlineIvUrl;

  @ViewChild('firstNameInput') firstNameInput!: ElementRef<HTMLInputElement>;

  constructor(private authService: SsoAuthService, private fb: FormBuilder, private router: Router, private dialog: MatDialog) { }

  ngOnInit() {
    this.profileForm = this.fb.group({
      firstName: [''],
      middleName: [''],
      lastName: [''],
      ritwikName: [''],
      email: [''],
      familyCode: [''],
      panNo: [''],
      aadharNo: [''],
      addressLine1: [''],
      addressLine2: [''],
      pincode: [''],
      postOffice: [''],
      state: [''],
      district: [''],
      otp: [''],
      contactNo: [''],
    });

    this.authService.getProfileDetails().subscribe({
      next: (res) => {
        this.memberDetails = res.data;
        this.profileForm.patchValue({
          firstName: this.memberDetails.firstName,
          middleName: this.memberDetails.middleName,
          lastName: this.memberDetails.lastName,
          ritwikName: this.memberDetails.ritwikName,
          email: this.memberDetails.email,
          familyCode: this.memberDetails.familyCode,
          panNo: this.memberDetails.panNo,
          aadharNo: this.memberDetails.aadharNo,
          addressLine1: this.memberDetails.addressLine1,
          addressLine2: this.memberDetails.addressLine2,
          pincode: this.memberDetails.pincode,
          postOffice: this.memberDetails.postOffice,
          state: this.memberDetails.state,
          district: this.memberDetails.district,
          contactNo: this.memberDetails.contactNo
        });
        this.memberDetails.country == 'NEPAL' ? this.orgUrl = environment.npOrgUrl : this.orgUrl
      },
      error: (error) => console.error(error)
    });



  }


  @ViewChild('popup') popupRef!: ElementRef;

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.popupRef && !this.popupRef.nativeElement.contains(event.target)) {
      this.showApps = false;
    }
  }
  
  onNumberChange(e: any) {
    console.log(e.target.value);
    const mobileNumber = e.target.value;
    const dialogRef = this.dialog.open(MobileChangePopup, {data: mobileNumber});
    
    dialogRef.afterClosed().subscribe((value: any) => {
      console.log(value)
      if(value){
        this.profileForm.get('contactNo')?.setValue(value);
      }
    })
    // this.profileForm.get('contactNo')?.valueChanges.subscribe(value => {
    //   if (value && value.length === 10) {
    //     this.updateContact(value)
    //   }
    // })
  }

  clickApps(url: string) {
    window.location.href = url;
  }

  toggleShowApps() {
    this.showApps = !this.showApps;
  }

  enableEdit() {
    this.isEditMode = true;
    this.profileForm.get('state')?.enable();
    this.profileForm.get('district')?.enable();
    this.profileForm.get('postOffice')?.enable()

    setTimeout(() => {
      this.firstNameInput.nativeElement.focus();
    }, 0);
  }

  onPincodeInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    console.log(value);

    if (value.length === 6) {
      this.fetchPincodeDetails(value);
    } else if (value.length < 6) {
      this.profileForm.get('state')?.reset()
      this.profileForm.get('district')?.reset()
      this.profileForm.get('postOffice')?.reset()
      this.allStates = [];
      this.allDistricts = [];
      this.allPostOffices = [];
    }
  }

  fetchPincodeDetails(pincode: string) {
    this.authService.getPincodeDetails(pincode).subscribe({
      next: (res) => {
        this.pinDetails = res.data
        const states = Object.keys(res.data)
        this.multiStateDataFromPincode = res.data;
        this.selectedState = states[0]
        this.allStates = states;
        this.selectedDistrict = Object.keys(res.data[this.selectedState])
        this.allDistricts = this.selectedDistrict.length > 1 ? this.selectedDistrict : []
        this.selectedPostOffice = res.data[this.selectedState][this.selectedDistrict[0]].po
        this.allPostOffices = this.selectedPostOffice.length > 1 ? this.selectedPostOffice : []
        //  this.allPostOffices = 
        console.log(this.allPostOffices)

        if (this.selectedDistrict.length === 1) {
          this.profileForm.patchValue({
            postOffice: this.selectedPostOffice.length < 2 ? this.selectedPostOffice[0] : this.selectedPostOffice,
            state: this.selectedState,
            district: this.selectedDistrict[0]
          })
        } else {
          if (this.allStates.length > 1) {
            this.profileForm.patchValue({
              state: states
            })
          } else {
            this.profileForm.patchValue({
              state: this.selectedState
            })
          }
        }

        console.log(this.profileForm.get('state')?.value)
      },
      error: (err) => console.error('Error fetching pincode details', err)
    });
  }

  // onDistrictChange(){
  //   console.log(this.selectedState);

  // // console.log(event);
  // this.profileForm.get('district')?.valueChanges.subscribe(district => {

  //       this.allPostOffices = this.pinDetails[this.selectedState as keyof PinDetails][district].po;
  //       // Reset PO FormControl to first PO of new district
  //       // this.form.get('po')?.setValue(this.allPOs[0]);
  //     });

  // }

  onChangeState(e: any){
    console.log(e.target.value)
    const changedState = e.target.value;
    if(!changedState) return;
    this.profileForm.get('district')?.reset();
    this.profileForm.get('postOffice')?.reset();
    const distData = this.multiStateDataFromPincode[changedState];
    console.log(changedState, distData, Object.keys(distData))
    this.allDistricts = Object.keys(distData);
    if(Object.keys(distData).length < 2){
      const distName = Object.keys(distData)[0];
      this.profileForm.get('postOffice')?.reset();
      this.profileForm.get('district')?.setValue(distName);
      console.log(distData[distName]);
      this.allPostOffices = distData[distName].po;
      if(distData[distName].po.length < 2){
        const poName = distData[distName].po[0]!
        this.profileForm.get('postOffice')?.setValue(poName);
      }
    }
  }

  onChangeDistrict(e: any, state: string) {
    this.profileForm.get('postOffice')?.reset();
    const distName = e.target.value;
    console.log(distName, state, this.multiStateDataFromPincode)
    this.allPostOffices = this.multiStateDataFromPincode[state][distName].po;
  }

  getFullName() {
    return [this.memberDetails.firstName, this.memberDetails.middleName, this.memberDetails.lastName]
      .filter(Boolean) // removes undefined, null, and empty strings
      .join(" ");
  }

  updateProfile() {
    if (!this.profileForm.valid) return;

    const payload = this.profileForm.value;
    const updatedData: any = {};


    Object.keys(this.profileForm.controls).forEach(key => {
      const control = this.profileForm.get(key);
      
      if (control && control.dirty) {
        console.log(key, control?.value)
        updatedData[key] = control.value;
      }
    });

    if (updatedData.hasOwnProperty('pincode')) {

      updatedData.state = this.profileForm.get('state')?.value;
      updatedData.district = this.profileForm.get('district')?.value;
      updatedData.postOffice = this.profileForm.get('postOffice')?.value;
    }

    this.authService.updateProfile(updatedData).subscribe({
      next: (res) => {
        // console.log('Profile updated', res);
        this.isEditMode = false;
        this.memberDetails = { ...this.memberDetails, ...payload };
        this.profileForm.get('state')?.disable();
        this.profileForm.get('district')?.disable();
        this.profileForm.get('postOffice')?.disable()
      },
      error: (err) => console.error('Error updating profile', err)
    });
  }

  logOut() {
    this.router?.navigate([''], { queryParams: { logout: true } });
  }


  updateContact(phNo: any) {
    const payload = {
      contactNo: String(phNo)
    }
    this.authService.updatePhoneNo(payload).subscribe({
      next: (res) => {
        this.isUpdateNo = true
        this.id = res.data.otpRequestId

      },
      error: (err) => console.error('Error updating phone No.', err)
    })
  }

  onOtpVerify() {
    this.profileForm.get('otp')?.valueChanges.subscribe(value => {
      if (value && value.length == 6) {
        this.verifyContact(value)
      }
    })
  }

  verifyContact(otpNo: any) {
    const payload = {
      contactNo: String(otpNo),
      id: this.id
    }
    this.authService.updatePhoneNo(payload).subscribe({
      next: (res) => {
        this.isUpdateNo = false
        // this.profileForm.patchValue({
        //   contactNo: 
        // })
      },
      error: (err) => console.error('Error verifying phone No.', err)
    })
  }
}
